<template>
	<div style="min-height: 75vh">

		<div class="offers-list__container" v-if="!loadingOffers">
			<InProgressOfferTile :id="index" @cardClicked="handleCardClick" v-for="(offer, index) in offersInProgress"
				:key="index" />
		</div>


		<div v-if="loadingOffers" class="offers-list__container">
			<v-skeleton-loader :elevation="4" type="list-item-avatar-three-line,divider,list-item-two-line"
				v-for="n in 20" :key="n" color="var(--v-skeleton-loader-color)"></v-skeleton-loader>
		</div>


		<EmptyList class="mx-auto mt-4" v-if="offersInProgress.length === 0">
			<template v-slot:title>
				Sorry, you haven't started any offers yet.
			</template>
		</EmptyList>


		<Pagination 
			:model-value="inProgressOfferStatusListPage"
			@update:model-value="(value) => inProgressOfferStatusListPage = value"
			:length="inProgressOfferStatusListPageLength" 
			:total-visible="totalVisible"
		/>

		<!-- Offer Details Dialog -->  
		<OfferDetailsDialog :offer="selectedOffer.offer" :noStartButton="true" @report-offer="openReportOfferDialog">
			<OfferSupport :support_info="selectedOffer.support_info"></OfferSupport>
		</OfferDetailsDialog>

		<!-- Report Offer Dialog -->
		<ReportOfferDialog />

	</div>
</template>



<script setup>

import { provide } from "vue";
import { computed, onMounted, ref } from "vue";
import { OfferStore } from "@/store/offerStore";
import EmptyList from "@/components/Common/Empty-List.vue";
import { OfferStatusStore } from "@/store/OfferStatusStore";
import Pagination from "@/components/Common/Pagination.vue";
import InProgressOfferTile from "@/components/Tiles/Offer/Status/InProgress-Offer-Status-Tile.vue";
import { usePagination } from "@/composables/usePagination";
import OfferSupport from '@/components/Offer/StartOfferDialogComponents/Offer-Support.vue';
import OfferDetailsDialog from '@/components/Offer/StartOfferDialogComponents/Offer-Details-Dialog.vue';
import ReportOfferDialog from '@/components/Offer/StartOfferDialogComponents/Report-Offer-Dialog.vue';

const offerStatusStore = OfferStatusStore();

const offerStore = OfferStore();
const loadingOffers = computed(() => offerStore.loadingOffers);

const offersInProgress = computed(() => offerStatusStore.offersInProgress);

// For offer details dialog
const offerDetailsDialogOpen = ref(false);
provide("offerDetailsDialogOpen", offerDetailsDialogOpen);

// For report offer dialog
const reportOfferDialogOpen = ref(false);
provide("reportOfferDialogOpen", reportOfferDialogOpen);

const selectedOffer = computed(() => offerStatusStore.selectedOffer);

// Use the pagination composable to handle pagination logic
const { pageNumber: inProgressOfferStatusListPage, pageLength: inProgressOfferStatusListPageLength, totalVisible } = usePagination({
	store: offerStatusStore,
	getTotalPages: (store) => store.offersInProgressPaging.totalPages,
	getCurrentPage: (store) => store.offersInProgressPaging.page,
	setPage: (store, page) => store.setOffersInProgressPage(page),
	fetchData: async (store) => await store.getAllMyOffers()
});

onMounted(() => {
	offerStatusStore.getAllMyOffers();
});

const handleCardClick = () => {
	offerDetailsDialogOpen.value = true;
};

const openReportOfferDialog = () => {
	offerDetailsDialogOpen.value = false;
	reportOfferDialogOpen.value = true;
};
</script>



<style scoped lang="scss">
@use "@/assets/scss/button-mixins" as button-mixins;
</style>